// Probably not the best place to put this code because a new file has been created just for this,
// But I don't know where to put it, except here
$(document).ready(function () {
    let submitLogin = $('#submit-login');

    submitLogin.on('click', function () {
        submitLogin.html('Login <i class="fa fa-spinner fa-pulse"></i>');
    });
})


// WEBPACK FOOTER //
// ./assets/js/login.js